import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';

import { Option } from '@shared/types/components.type';
import { PeriodType } from '@shared/utils/utils';

export const defaultVendorChangeFn = () => {};

export const defaultSnapshotChangeFn = () => {};

export const defaultSnapshotRefreshFn = () => {};

export const defaultPeriodList = [
  { label: 'Month', value: PeriodType.PERIOD_MONTH },
  { label: 'Quarter', value: PeriodType.PERIOD_QUARTER },
  { label: 'Year', value: PeriodType.PERIOD_YEAR },
];

export type BudgetCompareMenuFlatten$<T> = T extends Observable<infer R> ? R : null;

export type BudgetCompareMenuPeriodFormControl = FormControl<string>;

export type BudgetCompareMenuPeriodList = BudgetCompareMenuPeriodListItem[];

export type BudgetCompareMenuPeriodListItem = {
  label: string;
  value: PeriodType;
};

export type BudgetCompareMenuSnapshotChangeFn = (value: string) => void;

export type BudgetCompareMenuSnapshotDisabled = boolean;

export type BudgetCompareMenuSnapshotFormControl = FormControl<null | string>;

export type BudgetCompareMenuSnapshotList = Option<string>[];

export type BudgetCompareMenuSnapshotLoading = boolean;

export type BudgetCompareMenuSnapshotRefreshFn = () => void;

export type BudgetCompareMenuSnapshotShowDelete = boolean;

export type BudgetCompareMenuSnapshotShowEdit = boolean;

export type BudgetCompareMenuSnapshotValue = string | undefined;

export type BudgetCompareMenuVendorChangeFn = (vendorId: string) => void;

export type BudgetCompareMenuVendorFormControl = FormControl<string>;

export type BudgetCompareMenuVendorLoading = boolean;
